<template>
  <div class="scrollList">
    <div class="scrollList-hidden">
      <div class="scrollList-box" ref="scrollbox">
        <div
          class="scrollList-div"
          v-for="(item, index) in menuList"
          :key="index"
          @click="goScroll(index, item.Id)"
          :class="{menuChoose: scrollChoose == item.Id}"
          :style="{backgroundColor: backgroundColor}"
        >
          <span :style="{color: textColor}">{{item.Name}}</span>
        </div>
      </div>
    </div>
    <div class="tagDiv">
      <div class="tagDiv-box" :style="{left: (-100*scrollChoose)+'%'}">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    menuList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    backgroundColor: {
      type: String,
      default: "#ffffff"
    },
    textColor: {
      type: String,
      default: "#212121"
    },
    active: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      scrollChoose: 0,
      oldChoose: 0,
      newChoose: 0
    };
  },
  methods: {
    goScroll(index, id) {
      this.scrollChoose = id;
      this.newChoose = index;
      if (index >= 3 && this.newChoose > this.oldChoose) {
        let scWidth = this.$refs.scrollbox.children[index].clientWidth;
        this.$refs.scrollbox.scrollLeft += scWidth;
      } else if (
        this.newChoose < this.oldChoose &&
        index < this.menuList.length - 2
      ) {
        let scWidth = this.$refs.scrollbox.children[index].clientWidth;
        this.$refs.scrollbox.scrollLeft -= scWidth;
      }
      this.oldChoose = index;
      this.$emit("getchoose", id);
    },
    initScroll(id) {
      let inter = setInterval(() => {
        if (
          this.menuList.length > 0 &&
          this.$refs.scrollbox.children.length > 0
        ) {
          // sessionStorage.getItem("menuActive");
          // this.scrollChoose = sessionStorage.getItem("menuActive");
          this.scrollChoose = id;
          this.newChoose = this.menuList.findIndex(menu => {
            return menu.Id == this.scrollChoose;
          });

          if (this.newChoose > 3) {
            let scWidth = this.$refs.scrollbox.children[this.newChoose]
              .clientWidth;
            this.$refs.scrollbox.scrollLeft += scWidth * this.newChoose;
          }
          clearInterval(inter);
        }
      }, 100);
    }
  },
  mounted() {
    // if (this.menuList.length > 0) {
    this.initScroll(this.active);
    // }
  }
};
</script>

<style lang="scss" scoped>
.scrollList {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  .scrollList-hidden {
    width: 100%;
    height: 3rem;
    position: relative;
    overflow: hidden;
    .scrollList-box {
      width: 100%;
      height: 5rem;
      display: flex;
      overflow-x: auto;
      transition: 2s;
      .scrollList-div {
        width: 100%;
        min-width: 5rem;
        text-align: center;
        position: relative;
        height: 2rem;
        span {
          width: 100%;
          line-height: 2rem;
          font-size: 0.75rem;
          padding: 0.25rem 0.5rem;
        }
      }
    }
  }
  .tagDiv {
    width: 100%;
    height: 100%;
    overflow: hidden;
    .tagDiv-box {
      width: 100%;
      height: auto;
      display: flex;
      position: relative;
      transition: 0.5s;
    }
  }
}
.menuChoose {
  span {
    color: #333333 !important;
    font-weight: 500;
  }
  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 20;
    width: 1.87rem;
    border-bottom: 1px solid #e22519;
    // border-width: 1rem 0.5rem 0rem 0.5rem;
    // border-style: solid;
    // border-color: #ff0000 transparent transparent transparent;
  }
}
</style>